import React from "react";
import { Card, Elevation, Icon } from "@blueprintjs/core";
import { Translate } from "react-redux-i18n";
import FormatedPrice from "../FormatedPrice";
import Image from '../Image';

export default function SuggestionListCard({ suggestion, onClick }) {
  return (
    <Card
        interactive={true}
        elevation={Elevation.ONE}
        onClick={_ => onClick(suggestion.id)}
        className="product-card cover-image blocked-card">
        <div className="product-meta">
        <div className="product-image">
            <Image src={suggestion.images[0].url} alt={suggestion.name} />
        </div>
        </div>
        <div className="product-side-info">
        <h1 className="product-name">{suggestion.name}</h1>
        <div className="product-split">
            <Icon icon="people" iconSize="16" className="icon" />
            <span>{suggestion.suggested_members_no} <Translate value="collection_page.owners_suggested" /></span>
        </div>
        <div className="card-footer">
            <div className="product-price">
            <strong>
            <FormatedPrice
              value={suggestion.total_price/parseInt(suggestion.suggested_members_no)}
              currency_type={suggestion.currency}
            />            
            </strong>
            <small><Translate value="suggestion.per_person" /></small>
            </div>
            <Icon icon="chevron-right" iconSize="20" />
        </div>
        </div>
    </Card>    
  );
}
